import React from "react";
import styles from "../../styles";
import GridConfig from "./GridConfig";
import { withStyles, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import DrawerContainerStyles from "./style";
import DataGrid from "../../../../dataGrid";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import AddEditHoliday from "../AddEditHoliday";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import DeleteHoliday from "../DeleteHoliday";
import StatusBar from "../../../../dataGrid/StatusBar";
import { withTerminalsHOC } from "../../common/withTerminalsHOC";
import MESSAGES from "../../../../../appMessages";

class HolidayGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.state = {
      holidayList: [],
      errorMessage: null,
      showHolidayForm: false,
      quickFilterText: "",
      terminalList: [],
      holidayDetails: null,
      selectedHolidayData: null,
      stateList: [],
      countryList: [],
      selectedHoliday: [],
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.getAllHolidays();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.terminalList !== this.props.terminalList) {
      this.getAllDropdownOption(this.props.terminalList);
      if (this.props.TerminalDataMessage === "error") {
        this.props.enqueueSnackbar(
          MESSAGES.TERMINAL_ACCESS.FETCH_TERMINAL_DATA_FAILURE,
          { variant: "error" }
        );
      }
    }
  }

  getAllHolidays = () => {
    getDataWithQueryString("GetAllHolidays").then(
      (response) => {
        if (this._isComponentMounted) {
          if (response && response.status >= 200 && response.status < 400) {
            this.setState({
              holidayList: response.data,
              errorMessage: null,
            });
          } else {
            let errorMessage = MESSAGES.COMMON.GRID_DATA_FETCH_FAILED;

            this.setState({
              holidayList: [],
              errorMessage,
            });
            this.props.enqueueSnackbar(MESSAGES.COMMON.GRID_DATA_FETCH_FAILED, {
              variant: "error",
            });
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState({
            holidayList: [],
            errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED,
          });
          this.props.enqueueSnackbar(MESSAGES.COMMON.GRID_DATA_FETCH_FAILED, {
            variant: "error",
          });
        }
      }
    );
  };

  getAllDropdownOption = (terminalsData) => {
    const stateList = this.getOptions(
      terminalsData.map((terminal) => ({
        value: terminal.state,
        label: terminal.state,
        country: terminal.country,
      }))
    );
    const countryList = this.getOptions(
      terminalsData.map((terminal) => ({
        value: terminal.country,
        label: terminal.country,
      }))
    );

    const terminalList = terminalsData.map((terminal) => ({
      value: terminal.terminalCode,
      label: terminal.terminalCode,
      country: terminal.country,
      state: terminal.state,
    }));

    this.setState({
      terminalList,
      stateList,
      countryList,
    });
  };

  getFilterOptions = (data) => {
    return (
      data.map((option) => {
        return {
          value: option.value,
          text: option.value,
        };
      }) || []
    );
  };

  getOptions = (data) => {
    return [
      ...new Map(data.map((item) => [item["value"], item])).values(),
    ].filter((value) => Boolean(value.value));
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
  };

  openAddEditHolidayPanel = () => {
    this.setState({ showHolidayForm: true });
  };

  closeAddEditHolidayPanel = (selectedHoliday = []) => {
    this.setState({
      showHolidayForm: false,
      holidayDetails: null,
      selectedHoliday: selectedHoliday,
    });
  };

  // Calls different operations to be done on selected holiday
  runCommand = (command, props) => {
    const holidayDetails = { ...props.data };
    switch (command) {
      case "editHoliday":
        this.editHolidayInfo(holidayDetails);
        break;
      case "deleteHoliday":
        this.getSelectedHolidayData(holidayDetails);
        break;
      default:
        break;
    }
    // Save selection to retain it for data refresh
    this.setState({
      selectedHoliday: [holidayDetails.holidayId],
    });
  };

  // Opens the edit holiday panel for updating holiday information
  editHolidayInfo = (holidayDetails) => {
    this.setState({
      holidayDetails: holidayDetails,
      showHolidayForm: true,
    });
  };

  updateQuickFilterText = (event) => {
    this.setState({
      quickFilterText: event.target.value,
    });
  };

  getSelectedHolidayData = (holidayDetails) => {
    this.setState({
      selectedHolidayData: holidayDetails,
    });
  };

  onCancelHolidayDeletion = () => {
    this.setState({
      selectedHolidayData: null,
    });
  };

  selectedHoliday = () => {
    if (this.state.selectedHoliday.length && this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.state.selectedHoliday.includes(node.data.holidayId)) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true);
        } else {
          node.setSelected(false);
        }
      });
    }
  };

  constructStatusBar = (holidayList) => {
    return [
      {
        label: `${holidayList.length} Holidays`,
      },
    ];
  };

  render() {
    const { classes } = this.props;
    const {
      holidayDetails,
      terminalList,
      countryList,
      stateList,
      selectedHolidayData,
      showHolidayForm,
    } = this.state;
    return (
      <>
        <div className={`${classes.moduleContainer}`}>
          <div
            className={`${classes.gridContainer} ${classes.holidayGridContainer}`}
          >
            <div className={classes.gridHead}>
              <span className={classes.gridActionIcons}>
                <div className={classes.searchContainer}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    placeholder="Search…"
                    classes={{
                      root: classes.searchInputRoot,
                      input: classes.searchInput,
                    }}
                    onChange={this.updateQuickFilterText}
                  />
                </div>
              </span>
              <div className={classes.actionContainer}>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  classes={{ root: classes.actionButton }}
                  onClick={this.openAddEditHolidayPanel}
                  data-automationid="AddHoliday"
                >
                  + Add Holiday
                </Button>
              </div>
            </div>
            <div className={`${classes.dataGrid} ${classes.holidayGrid}`}>
              {!this.state.errorMessage ? (
                <DataGrid
                  defaultColDef={this.gridConfig.config.defaultColDef}
                  columnDefs={this.gridConfig.config.columns}
                  config={this.gridConfig.config}
                  enableFilter={this.gridConfig.config.enableFilter}
                  enableSorting={this.gridConfig.config.enableSorting}
                  rowSelection={this.gridConfig.config.rowSelection}
                  rowData={this.state.holidayList}
                  onGridReady={this.onGridReady}
                  suppressRowClickSelection={showHolidayForm}
                  onCellValueChanged={this.onCellValueChanged}
                  quickFilterText={this.state.quickFilterText}
                  context={{
                    terminalList: this.getFilterOptions(terminalList),
                    stateList: this.getFilterOptions(stateList),
                    countryList: this.getFilterOptions(countryList),
                  }}
                  onRowDataChanged={this.selectedHoliday}
                  panelLabel={(filteredData) => (
                    <StatusBar
                      data={this.constructStatusBar(filteredData)}
                      customClass={classes.statusBar}
                    />
                  )}
                />
              ) : (
                <div className={classes.errorMessageContainer}>
                  <div className={classes.errorMessage}>
                    {this.state.errorMessage}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {showHolidayForm && (
          <AddEditHoliday
            open={showHolidayForm}
            onClose={this.closeAddEditHolidayPanel}
            holidayDetails={holidayDetails}
            terminalList={terminalList}
            stateList={stateList}
            countryList={countryList}
            getAllHolidays={this.getAllHolidays}
            drawerClasses={{
              paper: classes.paperAnchor,
            }}
            variant="persistent"
          />
        )}
        {selectedHolidayData && (
          <DeleteHoliday
            onCancel={this.onCancelHolidayDeletion}
            getAllHolidays={this.getAllHolidays}
            selectedHolidayData={selectedHolidayData}
          />
        )}
      </>
    );
  }
}

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...DrawerContainerStyles(theme),
  })),
  withSnackbar
)(withTerminalsHOC(HolidayGrid));
